module.exports = __webpack_public_path__ + "img/LogoFB.1b6b83e4.png";